import React from "react"
import styled from 'styled-components';

const FormContainerSc = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

interface DivWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  // [key: string]: any
}

export class FormContainer extends React.Component<DivWrapperProps> {
  render() {
    const {children, ...rest} = this.props;
    return <FormContainerSc {...rest}>
      {children}
    </FormContainerSc>;
  }
}

export default FormContainer;
